<template src="./ProjectSelect.html"></template>

<script>
import { getProjects } from '../../services'

// XAN-193 — selector de un solo proyecto (activo), calcado de Forms/Users/Users.vue. Usado en el
// filtro de Tickets.html y en TicketFormDialog para asociar un ticket a un proyecto.
//
// XAN-193 (adjustments) — GET /project already comes narrowed by the backend to the projects the
// user is assigned to, so this picker never offers a project they cannot enter. ADMIN is the
// exception and sees them all.
export default {
  name: 'ProjectSelect',
  props: {
    value: {
      type: String,
      default: null
    },
    dense: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Proyecto'
    },
    // The project is mandatory in the ticket form, so it must not be clearable there; as a board
    // filter it is.
    clearable: {
      type: Boolean,
      default: true
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  model: {
    prop: 'value',
    event: 'update'
  },
  data: () => ({
    projects: []
  }),
  created () {
    this.listProjects()
  },
  methods: {
    async listProjects () {
      try {
        this.projects = await getProjects({ active: true })
      } catch (err) {
        console.error('Error listing projects:', err)
      }
    }
  }
}
</script>
